import { RootState } from '../../reducers';
import { TARGET_SEGMENT } from '../../cms/constants';

const selectTargetSegment = (state: RootState) =>
  state?.referral?.targetSegment ?? TARGET_SEGMENT.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE;

export default selectTargetSegment;
